import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/alliance/feature-1.svg';
import _imports_1 from '@/assets/alliance/feature-2.svg';
import _imports_2 from '@/assets/alliance/feature-3.svg';

const _withScopeId = n => (_pushScopeId("data-v-2c41a316"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "block"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "frame"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "block-wrapper"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "image-wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "block"
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "list-content-wrapper"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-h6"
}, "Share Community Traffic"), /*#__PURE__*/_createElementVNode("span", {
  class: "font-body2"
}, "Unite to support each other in the bearish market.")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "block-wrapper"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "image-wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "block"
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "list-content-wrapper"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-h6"
}, "Enhance NFT Liquidity"), /*#__PURE__*/_createElementVNode("span", {
  class: "font-body2"
}, "Increase the overall NFT transaction volume together.")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "block-wrapper"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "image-wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "block"
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "list-content-wrapper"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-h6"
}, "Gain Extra Benefits"), /*#__PURE__*/_createElementVNode("span", {
  class: "font-body2"
}, "Boost the value of NFT by joining the Alliance NFT to access multiple utilities.")])])], -1));

const _hoisted_3 = /*#__PURE__*/_createTextVNode("Alliance NFT ");

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_5 = /*#__PURE__*/_createTextVNode("Core Value");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Strengthen the community and utility via alliance power ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_block_with_image = _resolveComponent("block-with-image");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_block_with_image, {
    imagePosition: "right"
  }, {
    image: _withCtx(() => [_hoisted_2]),
    title: _withCtx(() => [_hoisted_3, _hoisted_4, _hoisted_5]),
    content: _withCtx(() => [_hoisted_6]),
    _: 1
  })]);
}